<template>
  <div>
    <div class="inner-wrap">
      <div class="title">
        <h3>경기 결과</h3>
      </div>
      <div class="content">
        <div class="match-information-area">
          <div class="match-information-wrap">
            <div class="match-information">
              <div class="left-area">
                <table class="summary-table">
                  <caption>경기 결과 요약 테이블</caption>
                  <colgroup>
                    <col width="108px">
                    <col>
                    <col width="108px">
                  </colgroup>
                  <tbody>
                  <tr>
                    <td>
                      <div class="team-area">
                        <div class="logo-area">
                          <img :src="awayTeamImage" :alt="awayTeamName + '로고'">
                        </div>
                        <h4>{{awayTeamName}}</h4>
                        <h5>
                          <img v-if="awayTeamScore > homeTeamScore" src="../../assets/images/kbo/icon-match-win.png" alt="승 아이콘 이미지">
                          <img v-else-if="homeTeamScore > awayTeamScore" src="../../assets/images/kbo/icon-match-lose.png" alt="패 아이콘 이미지">
                          <span>{{awayTeamPitcher}}</span>
                        </h5>
                      </div>
                    </td>
                    <td>
                      <div class="score-area">
                        <div class="middle-area">
                          <span class="score">{{awayTeamScore}}</span>
                          <span class="state">경기종료</span>
                          <span class="score">{{homeTeamScore}}</span>
                        </div>
                        <div class="bottom-area">
                          <div class="metadata">
                            <span class="date">{{gameDate}}</span>
                            <span class="start-time">{{gameTime}}</span>
                            <span class="location">({{gamePlace}})</span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <!-- 승 클래스: win / 패 클래스: lose -->
                      <div class="team-area win">
                        <div class="logo-area">
                          <img :src="homeTeamImage" :alt="homeTeamName + '로고'">
                        </div>
                        <h4>{{homeTeamName}}</h4>
                        <h5>
                          <img v-if="homeTeamScore > awayTeamScore" src="../../assets/images/kbo/icon-match-win.png" alt="승 아이콘 이미지">
                          <img v-else-if="awayTeamScore > homeTeamScore" src="../../assets/images/kbo/icon-match-lose.png" alt="패 아이콘 이미지">
                          <span>{{homeTeamPitcher}}</span>
                        </h5>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="right-area">
                <table class="score-table">
                  <caption>점수 테이블</caption>
                  <thead>
                  <tr>
                    <th></th>
                    <th v-for="(count, index) in inningCount" :key="index">{{count}}</th>
                    <th scope="col">R</th>
                    <th scope="col">H</th>
                    <th scope="col">E</th>
                    <th scope="col">B</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">{{awayTeamName}}</th>
                    <td v-for="(count, index) in inningCount" :key="index">{{getScore(awayItem, count)}}</td>
                    <td>{{run(awayItem)}}</td>
                    <td>{{hit(awayItem)}}</td>
                    <td>{{err(awayItem)}}</td>
                    <td>{{bb(awayItem)}}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{homeTeamName}}</th>
                    <td v-for="(count, index) in inningCount" :key="index">{{getScore(homeItem, count)}}</td>
                    <td>{{run(homeItem)}}</td>
                    <td>{{hit(homeItem)}}</td>
                    <td>{{err(homeItem)}}</td>
                    <td>{{bb(homeItem)}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  export default {
    name: 'GameResult',
    props: {
      vsScoreResult: {
        type: Object
      },
      inningResultList: {
        type: Array
      }
    },
    data () {
      return {
        lastInning: 9
      }
    },
    computed: {
      homeTeamImage () {
        return _.get(this.vsScoreResult, 'homeTeamImg', '')
      },
      homeTeamName () {
        return _.get(this.vsScoreResult, 'homeTeamName', '')
      },
      homeTeamPitcher () {
        return _.get(this.vsScoreResult, 'homeTeamPitcher', '-') || '-'
      },
      homeTeamScore () {
        return Number(_.get(this.vsScoreResult, 'homeTeamScore', 0))
      },
      awayTeamImage () {
        return _.get(this.vsScoreResult, 'awayTeamImg', '')
      },
      awayTeamName () {
        return _.get(this.vsScoreResult, 'awayTeamName', '')
      },
      awayTeamPitcher () {
        return _.get(this.vsScoreResult, 'awayTeamPitcher', '-') || '-'
      },
      awayTeamScore () {
        return Number(_.get(this.vsScoreResult, 'awayTeamScore', 0))
      },
      gamePlace () {
        return _.get(this.vsScoreResult, 'gamePlace', '')
      },
      gameDate () {
        const date = '' + _.get(this.vsScoreResult, 'gameDate', '')
        if (isNaN(Number(date)) || date.length === 0) return ''
        let month = Number(date.substr(4, 2))
        let day = Number(date.substr(6, 2))
        return `${month}/${day}`
      },
      gameTime () {
        return _.get(this.vsScoreResult, 'gameTime', '').replace(/(.{2})/, '$1:')
      },
      homeItem () {
        return _.get(_.filter(this.inningResultList, (inningItem) => inningItem.bhome === 'home'), '0', {})
      },
      awayItem () {
        return _.get(_.filter(this.inningResultList, (inningItem) => inningItem.bhome === 'away'), '0', {})
      },
      inningCount () {
        return this.lastInning <= 9 ? 9 : this.lastInning
      }
    },
    methods: {
      run (item) {
        return _.get(item, 'run', 0)
      },
      err (item) {
        return _.get(item, 'err', 0)
      },
      hit (item) {
        return _.get(item, 'hit', 0)
      },
      bb (item) {
        return _.get(item, 'bb', 0)
      },
      getScore (item, count) {
        return _.get(item, `inningScore${count}`, 0) || 0
      }
    },
    created () {
      this.$events.$on('nowInning', (nowInning) => {
        this.lastInning = nowInning
      })
    },
    beforeDestroy () {
      this.$events.$off('nowInning')
    }
  }
</script>

<style scoped>
  .kbo .score-table{
    margin: 27px 0;
  }

  .kbo .score-table thead th{
    border-top: 0;
  }

  .kbo .team-area h5 img,
  .kbo .team-area h5 span{
    display: inline-block;
    vertical-align: middle;
  }

  .kbo .team-area h5 img{
    width: 20px;
    height: 20px;
  }

  .kbo .team-area h5 img + span{
    margin-left: 4px;
  }
</style>
